import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import axios from '@/api/axios';
import i18n from '@/api/i18n/i18n';

Vue.use(VueToast);

function openToast(message, type) {
  Vue.$toast.open({
    message,
    type,
  });
}

export function getNotificationsHistory(userId, dateFrom, dateTo, page = 0, limit = 10) {
  return axios.post('/notifications', { userId, dateFrom, dateTo, page, limit }).then((response) => {
    if (response.data.success) {
      return response.data.result;
    }
    return 'error';
  });
}

export function checkRecord(record) {
  return axios.post(`/notifications/check/?id=${record}`).then((response) => {
    if (response.data.success) {
      if (record === 0) {
        openToast(i18n.t('toast.recordsSuccessfullyConfirmed'), 'success');
      } else {
        openToast(i18n.t('toast.recordSuccessfullyConfirmed'), 'success');
      }
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}
